import React from 'react';

const LandingPage = () => {
  return (
    <div style={{
      color: '#000000',
      backgroundColor: '#0072C6',
      margin: 0,
      minHeight: '100vh'
    }}>
      <div style={{
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center'
      }}>
        <a href="http://go.microsoft.com/fwlink/?linkid=66138&clcid=0x409">
          <img
            src="/assets/images/iisstart.png"
            alt="IIS"
            width="960"
            height="600"
            style={{ border: 'none' }}
          />
        </a>
      </div>
    </div>
  );
};

export default LandingPage;
